import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"col-lg-6 col-md-12 col-xs-12\"><div class=\"textcard\"><h2>7 Million+ Rotating <br>Residential Proxies</h2><br><ul><li>Back-connect rotating proxies</li><li>Unlimited concurrent connections</li><li>HTTP and HTTPs proxies.</li><li>7 million IP proxy network</li><li>Username &amp; password authentication</li><li>Select countries all around the globe</li></ul><a class=\"pricing-btn blue-btn mt-4\" href=\"#pricing\">PRICING</a></div></div><div class=\"col-lg-6 col-md-12 col-xs-12\"><div class=\"imagecard\"><img alt=\"how a residential proxy works\" src=\"https://cdn.proxyscrape.com/img/how_residential_work.jpg\"></div></div>", 2)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", {
  class: "col-12 text-center",
  style: {"margin-bottom":"30px"}
}, [
  /*#__PURE__*/_createElementVNode("h2", { class: "h4 mb-3" }, "and 121 other countries"),
  /*#__PURE__*/_createElementVNode("a", {
    class: "btn",
    href: "#pricing"
  }, " pricing ")
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "col-12 text-center" }, [
  /*#__PURE__*/_createElementVNode("a", {
    class: "btn",
    href: "#pricing",
    style: {"margin-bottom":"30px"}
  }, " pricing ")
], -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "textcard disclaimer" }, " The residential proxies are currently in beta. By purchasing, you understand that there might be little problems with the proxies. If you encounter any issues, please report them as soon as possible. ", -1)
const _hoisted_8 = { class: "row" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", {
  class: "col-12",
  style: {"padding-top":"10px","padding-bottom":"10px"}
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "elfsight-app-c349f1d8-7c7e-4b27-93c1-be19944e141b" })
], -1)

import ResidentialProxies from '@/components/services/residential/ResidentialProxies.vue';
import DProxyTypes from '@/components/services/residential/RProxyTypes.vue';
import TopLocations from '@/components/services/residential/TopLocations.vue';
import WhyResidential from '@/components/services/residential/WhyResidential.vue';
import UseCases from '@/components/shared/UseCases.vue';
import RQuickRecap from '@/components/services/residential/RQuickRecap.vue';
import RPricingCard from '@/components/services/residential/RPricingCard.vue';
import RProxiesPrice from '@/services/rproxies-price';
import RPricingCardLG from '@/components/services/residential/RPricingCardLG.vue';
import PaymentMethods from '@/components/shared/PaymentMethods.vue';
import ResidentialFAQ from '@/components/services/residential/ResidentialFAQ.vue';
import PageHead from '@/components/shared/PageHead.vue';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const head = {
  title: 'Residential proxies',
  subtitle: '7+ million residential proxy pool',
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(PageHead, { head: head }),
        _hoisted_3,
        _createVNode(ResidentialProxies),
        _createVNode(DProxyTypes),
        _createVNode(TopLocations),
        _hoisted_5,
        _createVNode(WhyResidential),
        _createVNode(UseCases),
        _hoisted_6,
        _createVNode(RQuickRecap),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(RProxiesPrice).slice(0, 6), (card) => {
          return (_openBlock(), _createBlock(RPricingCard, {
            key: card.id,
            card: card
          }, null, 8, ["card"]))
        }), 128)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(RProxiesPrice).slice(6, 8), (card) => {
          return (_openBlock(), _createBlock(RPricingCardLG, {
            key: card.id,
            card: card
          }, null, 8, ["card"]))
        }), 128)),
        _hoisted_7
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(PaymentMethods),
        _hoisted_9,
        _createVNode(ResidentialFAQ)
      ])
    ])
  ]))
}
}

})